enum XMLHttpResponseTypeEnum {
	arraybuffer = 'arraybuffer',
	blob = 'blob',
	document = 'document',
	json = 'json',
	text = 'text'
}

export default XMLHttpResponseTypeEnum;
